import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import Head from "next/head";
import Link from "next/link";
import useLocalStorage from "hooks/useLocalStorage";
import { getCanonicalSiteUrl, getStorageKey } from "@/lib/regions/client";
import Search from "@/components/Search";
import Favourites from "@/components/Favourites";
import LocationMarker from "@catchy/assets/svgs/location-mono.svg";
export default function IndexPage(t0) {
  const $ = _c(18);
  const {
    isApple,
    isClient,
    mapsSupported,
    preferredStopNames
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getCanonicalSiteUrl();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const siteUrl = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getStorageKey("last_main");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [, setLastMain] = useLocalStorage(t2, null);
  let t3;
  let t4;
  if ($[2] !== setLastMain) {
    t3 = () => {
      setLastMain("bus");
    };
    t4 = [setLastMain];
    $[2] = setLastMain;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Head><title key="title">{"Otago bus departures, maps and trip tracking \u2014 Catchy"}</title><meta name="twitter:text:title" content={"Otago bus departures, maps and trip tracking \u2014 Catchy"} key="twitterTitle" /><meta name="twitter:text:description" content="Check live Orbus departures, nearby stops, and trip tracking across Dunedin and Otago." key="twitterDescription" /><meta property="og:title" content={"Otago bus departures, maps and trip tracking \u2014 Catchy"} key="ogTitle" /><meta property="og:description" content="Check live Orbus departures, nearby stops, and trip tracking across Dunedin and Otago." key="ogDescription" /><meta name="description" content="Check live Orbus departures, nearby stops, and trip tracking across Dunedin and Otago." key="description" /><meta property="og:image" content="https://otago.catchy.nz/share/share-bus.png" key="ogImage" /><meta property="og:url" content={siteUrl} key="ogUrl" /><link rel="canonical" href={siteUrl} key="canonicalUrl" /></Head>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== preferredStopNames) {
    t6 = <Search type="all" preferredStopNames={preferredStopNames} />;
    $[6] = preferredStopNames;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== mapsSupported) {
    t7 = mapsSupported ? <div className="px-[20px] py-2"><Link href="/map?from=bus" className="flex w-full items-center justify-center rounded-full py-2 pl-4 pr-6 text-center font-semibold text-blue-600 ring-1 ring-blue-500/50 transition-colors duration-200 hover:bg-blue-400/10 focus:outline-none focus-visible:ring dark:text-blue-400 dark:ring-blue-400/50"><LocationMarker className="mr-2 h-[1.125rem] w-[1.125rem]" />Map of stops and current trips</Link></div> : null;
    $[8] = mapsSupported;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isApple || $[11] !== isClient || $[12] !== preferredStopNames) {
    t8 = <div className="mt-4 flex flex-col gap-8"><Favourites isApple={isApple} isClient={isClient} preferredStopNames={preferredStopNames} type="bus" /></div>;
    $[10] = isApple;
    $[11] = isClient;
    $[12] = preferredStopNames;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = <>{t5}<div className="mb-20 flex flex-col pt-4">{t6}{t7}{t8}</div></>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}